import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { JoursCompteur } from './UI';
import { MessageBell } from './MessageBell';
import logo from '../assets/logo_brandstarter.png';

const css = `
  .bs-nav { background: #fff; border-bottom: 1px solid #E3DCCF; height: 60px; display: flex; align-items: center; justify-content: space-between; padding: 0 14px; position: sticky; top: 0; z-index: 100; gap: 8px; }
  .bs-nav-logo { display: flex; align-items: center; flex-shrink: 0; }
  .bs-nav-logo img { height: 30px; width: auto; display: block; }
  .bs-nav-right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; position: relative; }
  .bs-nav-back { background: transparent; border: 1.5px solid #E3DCCF; color: #173B34; font-size: 0.85rem; font-weight: 600; min-height: 44px; padding: 0 16px; border-radius: 999px; cursor: pointer; font-family: 'Inter', sans-serif; text-decoration: none; white-space: nowrap; display: inline-flex; align-items: center; }
  .bs-nav-compteur-desk { display: none; }
  .bs-nav-user-btn { display: flex; align-items: center; gap: 6px; background: #F6F2EC; border: 1.5px solid #E3DCCF; color: #173B34; font-size: 0.85rem; font-weight: 600; min-height: 44px; padding: 0 14px; border-radius: 999px; cursor: pointer; font-family: 'Inter', sans-serif; white-space: nowrap; }
  .bs-nav-name-txt { display: none; }
  .bs-nav-chevron { font-size: 0.6rem; color: #888; transition: transform 0.2s; }
  .bs-nav-chevron.open { transform: rotate(180deg); }
  .bs-dropdown { position: absolute; top: calc(100% + 8px); right: 0; background: white; border: 1px solid #E3DCCF; border-radius: 14px; box-shadow: 0 8px 24px rgba(0,0,0,0.15); min-width: 200px; overflow: hidden; z-index: 200; animation: dropIn 0.15s ease; }
  @keyframes dropIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
  .bs-dropdown-item { display: flex; align-items: center; gap: 10px; padding: 14px 16px; min-height: 48px; font-size: 0.92rem; font-family: 'Inter', sans-serif; color: #173B34; text-decoration: none; cursor: pointer; border: none; background: none; width: 100%; text-align: left; }
  .bs-dropdown-item:hover { background: #F6F2EC; }
  .bs-dropdown-item.danger { color: #E4572E; }
  .bs-dropdown-divider { height: 1px; background: #E3DCCF; margin: 2px 0; }
  @media (max-width: 359px) {
    .bs-nav { padding: 0 10px; gap: 4px; }
    .bs-nav-logo img { height: 26px; }
    .bs-nav-back, .bs-nav-user-btn { padding: 0 10px; font-size: 0.8rem; }
  }
  @media (min-width: 768px) {
    .bs-nav { padding: 0 32px; height: 64px; }
    .bs-nav-logo img { height: 34px; }
    .bs-nav-compteur-desk { display: flex; }
    .bs-nav-name-txt { display: inline; }
  }
`;

export function Navbar({ showBack = false }) {
  const { user, logout } = useAuth();
  const joursRestants = user?.joursRestants ?? 0;
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Fermer le menu si on clique ailleurs
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <>
      <style>{css}</style>
      <nav className="bs-nav">
        {/* LOGO */}
        <a href="/parcours" className="bs-nav-logo">
          <img src={logo} alt="BrandStarter" />
        </a>

        {/* DROITE */}
        <div className="bs-nav-right" ref={ref}>
          {/* Compteur — desktop uniquement */}
          {joursRestants > 0 && !user?.isAdmin && (
            <div className="bs-nav-compteur-desk">
              <JoursCompteur jours={joursRestants} />
            </div>
          )}

          {/* Retour au parcours */}
          {showBack && (
            <a href="/parcours" className="bs-nav-back">← Parcours</a>
          )}

          <MessageBell />

          {/* Menu utilisateur */}
          <button className="bs-nav-user-btn" onClick={() => setOpen(o => !o)}>
            👤 <span className="bs-nav-name-txt">{user?.prenom}</span>
            <span className={`bs-nav-chevron ${open ? 'open' : ''}`}>▼</span>
          </button>

          {/* Dropdown */}
          {open && (
            <div className="bs-dropdown">
              <a href="/ma-marque" className="bs-dropdown-item" onClick={() => setOpen(false)}>
                🧭 Ma marque
              </a>
              <a href="/profil" className="bs-dropdown-item" onClick={() => setOpen(false)}>
                👤 Mon profil
              </a>
              <div className="bs-dropdown-divider" />
              <button className="bs-dropdown-item danger" onClick={() => { setOpen(false); logout(); }}>
                🚪 Déconnexion
              </button>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
